import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	removeAttributeVocabularyValue,
	type QueryError,
	type RemoveAttributeVocabularyValueResult,
	type RemoveAttributeVocabularyValueRequestOptions,
} from '../removeAttributeVocabularyValue';
export * from '../removeAttributeVocabularyValue';

export type RemoveAttributeVocabularyValueQueryOptions = Omit<
	UseMutationOptions<
		RemoveAttributeVocabularyValueResult,
		QueryError,
		RemoveAttributeVocabularyValueRequestOptions,
		RemoveAttributeVocabularyValueResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof removeAttributeVocabularyValue;
};

/**
 * react-query wrapper for `removeAttributeVocabularyValue`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryRemoveAttributeVocabularyValue = ({
	mutationFn = removeAttributeVocabularyValue,
	...options
}: RemoveAttributeVocabularyValueQueryOptions = {}) =>
	useMutation<
		RemoveAttributeVocabularyValueResult,
		QueryError,
		RemoveAttributeVocabularyValueRequestOptions,
		RemoveAttributeVocabularyValueResult
	>({
		mutationFn: removeAttributeVocabularyValue,
		...options,
	});

export default useReactQueryRemoveAttributeVocabularyValue;
